import {StringToNumber, StringToNumberOrDouble} from "../../../../util/stringToNumber";

export const FORM_VALIDATE_ACTIONS = {
  VALIDATE_NAME: "name",
  VALIDATE_CODE: "code",
  VALIDATE_VALID_FROM: "validFrom",
  VALIDATE_VALID_TO: "validTo",
  VALIDATE_DATE: "valid_date",
  VALIDATE_DISCOUNT_PERCENTAGE: "discountPercentage",
  VALIDATE_DISCOUNT_FIXED_PRICE: "discountFixedPrice",
  VALIDATE_MINIMUM_BASKET_PRICE: "minimumBasketPrice",
  VALIDATE_MAXIMUM_DISCOUNT_PRICE: "maximumDiscountPrice",
  VALIDATE_AMOUNT: "amount",
  VALIDATE_USED_QTY: "used_qty",
  VALIDATE_CODE_EXIST: "VALIDATE_CODE_EXIST",
  RESET_FORM_ERROR: "RESET_FORM_ERROR",
  VALIDATE_FREE_DELIVERY: "free_delivery",
  VALIDATE_ALL_FIELD: "all",
  RESET_ERROR_FIELD_DISCOUNT_FIXED_PRICE_AND_MAXIMUM_DISCOUNT_PRICE:
    "RESET_ERROR_FIELD_DISCOUNT_FIXED_PRICE_AND_MAXIMUM_DISCOUNT_PRICE",
};

/**
 * The Free Delivery checkbox stores 1 / 0 (as string or number depending on
 * whether it came from the form or from a loaded coupon).
 */
export const isFreeDeliveryCoupon = (formState) => {
  const freeDelivery = formState?.free_delivery;
  return freeDelivery === true || StringToNumber(freeDelivery) === 1;
};

/**
 * A coupon needs a discount value, EXCEPT when it is a free delivery coupon -
 * there the delivery fee is the whole benefit, so 0 percentage / 0 fixed price
 * is a valid combination (the API stores explicit zeros for this case).
 */
export const isDiscountSatisfied = (formState) =>
  isFreeDeliveryCoupon(formState) ||
  StringToNumberOrDouble(formState?.discountFixedPrice) > 0 ||
  StringToNumberOrDouble(formState?.discountPercentage) > 0;

export const INITIAL_FORM_ERRORS = {
  isFormValid: false,
  formErrors: {},
};

// A free delivery voucher does not require a percentage/fixed-price discount,
// so a 0 discount value is acceptable when this flag is set.
const isFreeDelivery = (formState) =>
  formState?.free_delivery == 1 || formState?.free_delivery === "1";

export const formValidateReducer = (state, action , FormType = 'generateAndManual') => {
  let errors = { ...state.formErrors };
  switch (action.type) {
    case FORM_VALIDATE_ACTIONS.VALIDATE_CODE_EXIST: {
      errors["code"] = "Coupon code already exists";
      return {
        ...state,
        formErrors: errors,
        isFormValid: !Object.keys(errors).length,
      };
    }

    case FORM_VALIDATE_ACTIONS.VALIDATE_MINIMUM_BASKET_PRICE: {
      let { name, value, formState } = action.payLoad;
      let errorMessage = "";
      if (value === "") {
        errorMessage = "Required";
      } else if (StringToNumber(value) < 0) {
        errorMessage = "Must be greater than or equal 0";
      }

      if (errorMessage) {
        errors[name] = errorMessage;
      } else {
        delete errors[name];
      }

      return {
        ...state,
        formErrors: errors,
        isFormValid:
          !Object.keys(errors).length &&
          formState.code &&
          formState.name &&
          StringToNumber(formState.amount) &&
          formState.validFrom &&
          formState.validTo &&
          formState.minimumBasketPrice &&
          (isFreeDelivery(formState) || StringToNumberOrDouble(formState.discountFixedPrice) || StringToNumberOrDouble(formState.discountPercentage))? true: false
      };
    }

    // check validate string
    case FORM_VALIDATE_ACTIONS.VALIDATE_NAME:
    case FORM_VALIDATE_ACTIONS.VALIDATE_CODE:
    case FORM_VALIDATE_ACTIONS.VALIDATE_USED_QTY:
    case FORM_VALIDATE_ACTIONS.VALIDATE_VALID_TO:
    case FORM_VALIDATE_ACTIONS.VALIDATE_VALID_FROM: {
      if (FormType !== "template") {
        const {name, value, formState} = action.payLoad;
        if (!value) {
          errors[name] = "Required";
        } else {
          delete errors[name];
        }

        return {
          ...state,
          formErrors: errors,
          isFormValid:
              !Object.keys(errors).length &&
              formState.code &&
              formState.name &&
              StringToNumber(formState.amount) &&
              formState.validFrom &&
              formState.validTo &&
              formState.valid_date &&
              formState.minimumBasketPrice &&
              (isFreeDelivery(formState) || (StringToNumberOrDouble(formState.discountFixedPrice) && StringToNumberOrDouble(formState.discountPercentage))) ? true : false
        };
      }else {
        const {name, value, formState} = action.payLoad;
        delete errors[name];
      }
    }
    case FORM_VALIDATE_ACTIONS.VALIDATE_DATE: {
      const { name, value, formState } = action.payLoad;
      if (!value) {
        errors[name] = "Required";
      } else if(value <= 0 && value.length <= 3) {
        errors[name] = "Validate Must be greater than 0";
      }else {
        delete errors[name];
      }

      return {
        ...state,
        formErrors: errors,
        isFormValid:
          !Object.keys(errors).length &&
          formState.code &&
          formState.name &&
          StringToNumber(formState.amount) &&
          formState.validFrom &&
          formState.validTo &&
          formState.valid_date &&
          formState.minimumBasketPrice &&
          (isFreeDelivery(formState) || StringToNumberOrDouble(formState.discountFixedPrice) || StringToNumberOrDouble(formState.discountPercentage)) ? true: false
      };
    }

    // check validate number
    case FORM_VALIDATE_ACTIONS.VALIDATE_DISCOUNT_PERCENTAGE:
    case FORM_VALIDATE_ACTIONS.VALIDATE_USED_QTY:
    case FORM_VALIDATE_ACTIONS.VALIDATE_DISCOUNT_FIXED_PRICE:{
      let { value, formState } = action.payLoad;
      formState.discountFixedPrice = value;
      formState.discountPercentage = value;

      // A free delivery coupon may have a 0 discount - the free delivery is the
      // benefit - so only a negative value is rejected there.
      const allowsZeroDiscount = isFreeDeliveryCoupon(formState);
      const discountValue = StringToNumberOrDouble(value);

      let errorMessage = "";
      if (value === "") {
        errorMessage = "Required";
      } else if (allowsZeroDiscount && discountValue < 0) {
        errorMessage = "Must be greater than or equal 0";
      } else if (!allowsZeroDiscount && discountValue <= 0) {
        errorMessage = "Must be greater than 0";
      }

      if (errorMessage) {
        errors['discountPercentage'] = errorMessage;
        errors['discountFixedPrice'] = errorMessage
      } else {
        delete errors['discountPercentage'];
        delete errors['discountFixedPrice'];
      }

      return {
        ...state,
        formErrors: errors,
        isFormValid:
          !Object.keys(errors).length &&
          formState.code &&
          formState.name &&
          StringToNumber(formState.amount) &&
          formState.validFrom &&
          formState.validTo &&
          formState.valid_date &&
          formState.minimumBasketPrice &&
          (isFreeDelivery(formState) || (StringToNumberOrDouble(formState.discountFixedPrice) && StringToNumberOrDouble(formState.discountPercentage)))? true: false
      };
    }
    case FORM_VALIDATE_ACTIONS.VALIDATE_MINIMUM_BASKET_PRICE:
    case FORM_VALIDATE_ACTIONS.VALIDATE_MAXIMUM_DISCOUNT_PRICE:
    case FORM_VALIDATE_ACTIONS.VALIDATE_AMOUNT: {
      let { name, value, formState } = action.payLoad;
      let errorMessage = "";
      if (value === "") {
        errorMessage = "Required";
      } else if (StringToNumber(value) <= 0) {
        errorMessage = "Must be greater than 0";
      }

      if (errorMessage) {
        errors[name] = errorMessage;
      } else {
        delete errors[name];
      }

      return {
        ...state,
        formErrors: errors,
        isFormValid:
          !Object.keys(errors).length &&
          formState.code &&
          formState.name &&
          StringToNumber(formState.amount) &&
          formState.validFrom &&
          formState.validTo &&
          formState.valid_date &&
          formState.minimumBasketPrice &&
          (isFreeDelivery(formState) || (StringToNumberOrDouble(formState.discountFixedPrice) && StringToNumberOrDouble(formState.discountPercentage)))? true: false
      };
    }

    // check validate all field before submit
    case FORM_VALIDATE_ACTIONS.VALIDATE_ALL_FIELD: {
      const formState = action.payLoad;

      const errors = {};
      if (!formState.name) {
        errors.name = "Required";
      } else {
        delete errors.name;
      }

      if (!formState.code) {
        errors.code = "Required";
      } else {
        delete errors.code;
      }

      if (!formState.validFrom) {
        errors.validFrom = "Required";
      } else {
        delete errors.validFrom;
      }

      if (!formState.validTo) {
        errors.validTo = "Required";
      } else {
        delete errors.validTo;
      }

      if (!formState.valid_date) {
        errors.valid_date = "Required";
      } else if(formState.valid_date <= 0){
        errors.valid_date = "Validate Must be greater than 0";
      } else {
        delete errors.valid_date;
      }

      // discount value
      // Free delivery vouchers don't need a percentage/fixed-price discount,
      // so a 0 discount is allowed when the free delivery flag is set.
      if (isFreeDelivery(formState)) {
        delete errors.discountPercentage;
        delete errors.discountFixedPrice;
      } else if (
        !(formState.discountPercentage !== "" || formState.discountFixedPrice !== "")
      ) {
        errors.discountPercentage = "Required";
        errors.discountFixedPrice = "Required";
      }
      else if(!(StringToNumberOrDouble(formState.discountPercentage) > 0 || StringToNumberOrDouble(formState.discountFixedPrice) > 0)){
        errors.discountPercentage = "Must be greater than 0";
        errors.discountFixedPrice = "Must be greater than 0";
      }
      else {
        delete errors.discountPercentage;
        delete errors.discountFixedPrice;
      }

      if (formState.amount === "") {
        errors.amount = "Required";
      } else if (StringToNumber(formState.amount) <= 0) {
        errors.amount = "Must be greater than 0";
      } else {
        delete errors.amount;
      }

      if (formState.used_qty === "") {
        errors.used_qty = "Required";
      } else if (StringToNumber(formState.used_qty) <= 0) {
        errors.used_qty = "Must be greater than 0";
      } else {
        delete errors.used_qty;
      }

      if (formState.minimumBasketPrice === "") {
        errors.minimumBasketPrice = "Required";
      } else if (StringToNumber(formState.minimumBasketPrice) < 0) {
        errors.minimumBasketPrice = "Must be greater than or equal 0";
      } else {
        delete errors.minimumBasketPrice;
      }

      return {
        ...state,
        formErrors: errors,
        isFormValid: !Object.keys(errors).length,
      };
    }
    // Toggling Free Delivery changes whether a 0 discount is acceptable, so the
    // discount errors are re-evaluated instead of being left stale on the form.
    case FORM_VALIDATE_ACTIONS.VALIDATE_FREE_DELIVERY: {
      const { formState } = action.payLoad;

      if (isDiscountSatisfied(formState)) {
        delete errors.discountPercentage;
        delete errors.discountFixedPrice;
      } else if (
        formState.discountPercentage !== "" &&
        formState.discountFixedPrice !== ""
      ) {
        errors.discountPercentage = "Must be greater than 0";
        errors.discountFixedPrice = "Must be greater than 0";
      }

      return {
        ...state,
        formErrors: errors,
        isFormValid:
          !Object.keys(errors).length &&
          formState.code &&
          formState.name &&
          StringToNumber(formState.amount) &&
          formState.validFrom &&
          formState.validTo &&
          formState.valid_date &&
          formState.minimumBasketPrice &&
          isDiscountSatisfied(formState) ? true : false
      };
    }
    case FORM_VALIDATE_ACTIONS.RESET_FORM_ERROR: {
      return INITIAL_FORM_ERRORS;
    }
    default:
      return state;
  }
};
